export const FontStyles = {
    halant: {
        fontFamily: "halant",
        fill: 0xffffff,
    },
    halant_bold: {
        fontFamily: "halant_bold",
        fill: 0xffffff,
    },
    balance: {
        fontFamily: "halant_bold",
        fontSize: 24,
        fill: 0xffffff,
    },
    win: {
        fontFamily: "halant_bold",
        fontSize: 24,
        fill: 0xF9CD82,
    },
    bet: {
        fontFamily: "halant_bold",
        fontSize: 20,
        fill: 0xffffff,
    },
};
